var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",staticClass:"w-100",attrs:{"id":_vm.id,"preload":"none","playsinline":"","autoplay":"","muted":""},domProps:{"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }